import {capitalize} from '@mui/material';

import {HomeEnum, QueryParamsEnum} from 'presentation/constants';

import {GuideStep} from 'presentation/modules/guide/shared/constants/constants';
import {useMediaQueries, useQueryParams} from 'presentation/pages/private';
import {translations} from 'presentation/translations-new';
import {useGuideQueryParams} from 'presentation/modules/guide/shared/hooks/useGuideQueryParams';
import {useGuideStore} from 'presentation/modules/guide/shared/store/guideStore';
import {useLocation, useNavigate} from 'react-router-dom';

const {location, details, results} = translations['pt-br'].commons;

export function useOdontoGuideHeader() {
	const {SEARCH_PARAMS, setSearchParams} = useQueryParams();
	const navigate = useNavigate();
	const {state: routeState} = useLocation();
	const {isMobile} = useMediaQueries();
	const {deleteAllQueryParams} = useGuideQueryParams();
	const resetOdontoStates = useGuideStore(state => state.resetOdontoStates);

	const {step: currentStepState} = SEARCH_PARAMS;

	const stepLabels = [location, details, `${capitalize(results)}`];

	const handleBack = () => {
		if (currentStepState === GuideStep.RESULTS) {
			setSearchParams(prev => {
				prev.set(QueryParamsEnum.STEP, GuideStep.DETAILS);
				return prev;
			});
			return;
		}

		if (currentStepState === GuideStep.DETAILS) {
			resetOdontoStates();
			deleteAllQueryParams();
			return;
		}

		if (routeState) {
			navigate(routeState);
			return;
		}
		navigate(HomeEnum.HOME_PAGE);
	};

	const handleClose = () => {
		if (routeState) {
			navigate(routeState);
			return;
		}

		navigate(HomeEnum.HOME_PAGE);
	};

	return {
		stepLabels,
		currentStepState,
		isMobile,
		handleBack,
		handleClose,
	};
}
